<template>
    <div class="head" :class="{x}">
        <div class="logo"></div>
        <div class="til">
            <slot>
                標題
            </slot>
        </div>
        <div class="menu" @click="$emit('ck')"></div>
    </div>
</template>

<script>
export default {
    props: ['x']
}
</script>

<style lang="less" scoped>
@import 'val.less';
.head {
    height: 55px;
    padding: 0px 17px;
    background: @main-color;
    text-align: left;
    .logo {
        float: left;
        width: 80px;
        height: 100%;
        // background-image: url('../assets/img/bitmapCopy.png');
        background-image: url('../assets/img/nav-logo@3x.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
    .til {
        float: left;
        height: 100%;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        line-height: 55px;
        margin: 0px 0px 0px 10px;
    }
    .menu {
        float: right;
        width: 28px;
        height: 100%;
        background-image: url('../assets/img/menu.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        &:active {
            filter: brightness(80%);
        }
    }
    &.x {
        padding: 0px 22px 0px 17px;
        .menu {
            width: 22px;
            background-image: url('../assets/img/group.png');
        }
    }
}

@media only screen and (min-width: @rwd) {
    .head {
        box-sizing: border-box;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        background: none;
        .logo {
            display: none;
        }
        .til {
            color: @main-color;
            font-size: 24px;
            display: flex;
            align-items: center;
            margin-top: 19px;
            &:before {
                content: '';
                display: block;
                width: 9px;
                height: 55px;
                background: url('../assets/img/group-bar.png');
                background-position: center;
                background-repeat: no-repeat;
                margin-right: 10px;
            }
        }
    }
    &.x {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue